import jumpseller from '@/assets/plugins/Logo_jumpseller.svg';
import mercadoEnvios from '@/assets/plugins/Logo_mercadoEnvios.svg';
import shopify from '@/assets/plugins/Logo_shopify.svg';
import tiendaNube from '@/assets/plugins/Logo_tiendanube.svg';
import woocommerce from '@/assets/plugins/Logo_woocommerce.svg';
import { Platform } from '@/types/parcel/orders';
import { IResStatisticsData } from '@/types/parcel/orders/statistics.interface';

export function convertDataToPercentage(
  data: IResStatisticsData,
  labels: Array<Record<keyof IResStatisticsData, string>>,
) {
  const principalKeys: Array<keyof IResStatisticsData> = [
    'totalProcess',
    'totalHistory',
    'totalReview',
  ];
  const total = principalKeys.reduce((sum, key) => sum + data[key], 0);

  return labels.map((group) => {
    const principalKey = Object.keys(group).find((key) =>
      principalKeys.includes(key as keyof IResStatisticsData),
    );
    return Object.entries(group).map(([key, label]) => {
      let percentage;
      if (principalKeys.includes(key as keyof IResStatisticsData)) {
        percentage = (data[key as keyof IResStatisticsData] / total) * 100;
      } else {
        percentage =
          (data[key as keyof IResStatisticsData] / data[principalKey as keyof IResStatisticsData]) *
          100;
      }
      return {
        name: label,
        value: isNaN(percentage) ? 0 : Number(percentage.toFixed(0)),
        realQuantity: data[key as keyof IResStatisticsData],
        color: colorByLabel[key] ?? '#12344A',
      };
    });
  });
}

export const filters = [
  {
    filterName: 'statusFilter',
    items: [
      { value: 'onPickup' },
      { value: 'stored' },
      { value: 'onP99' },
      { value: 'onRoadToDelivery' },
      { value: 'incident' },
      { value: 'onReview' },
      { value: 'delivered' },
      { value: 'returned' },
      { value: 'cancelled' },
    ],
  },
  {
    filterName: 'deliveryType',
    items: [
      { value: 'SMD' },
      { value: 'SPT' },
      { value: 'CO2F' },
      { value: '99M' },
      { value: 'RET' },
      { value: 'NAL' },
      { value: 'ECO' },
      { value: 'TLM' },
      { value: 'XBD' },
    ],
  },
  {
    filterName: 'platform',
    items: [
      { value: Platform.Shopify },
      { value: Platform.WooCommerce },
      { value: Platform.Magento },
      { value: Platform.TiendaNube },
      { value: Platform.JumpSeller },
      { value: Platform.BigCommerce },
      { value: Platform.MeliFlex },
      { value: Platform.TikTok },
      { value: Platform.API_V1 },
      { value: Platform.API_V3 },
      { value: Platform.HubPlatform },
      { value: Platform.MassiveLoad },
      { value: Platform.Fulfill99 },
    ],
  },
];

export const colorByLabel: Record<string, string> = {
  stored: '#A2D93F',
  onP99: '#365265',
  onRoadToDelivery: '#E1F5D8',
  totalProcess: '#12344A',
  delivered: '#72B632',
  returned: '#A2D93F',
  cancelled: '#EC645E',
  totalHistory: '#12344A',
  incident: '#EC645E',
  onReview: '#12344A',
  totalReview: '#E1F5D8',
};

const platformLogos: Record<string, string> = {
  [Platform.Shopify]: shopify,
  [Platform.WooCommerce]: woocommerce,
  [Platform.Magento]: woocommerce,
  [Platform.TiendaNube]: tiendaNube,
  [Platform.JumpSeller]: jumpseller,
  [Platform.BigCommerce]: woocommerce,
  [Platform.MeliFlex]: mercadoEnvios,
  [Platform.TikTok]: woocommerce,

  [Platform.API_V1]: '',
  [Platform.API_V3]: '',
  [Platform.HubPlatform]: '',
  [Platform.MassiveLoad]: '',
  [Platform.Fulfill99]: '',
};

const platformNames: Record<string, string> = {
  [Platform.API_V1]: 'API V1',
  [Platform.API_V3]: 'API V3',
  [Platform.HubPlatform]: 'Hub Platform',
  [Platform.MassiveLoad]: 'Carga Masiva',
  [Platform.Fulfill99]: 'Fulfill99',
  [Platform.Shopify]: 'Shopify',
  [Platform.WooCommerce]: 'WooCommerce',
  [Platform.Magento]: 'Magento',
  [Platform.TiendaNube]: 'Tienda Nube',
  [Platform.JumpSeller]: 'JumpSeller',
  [Platform.BigCommerce]: 'BigCommerce',
  [Platform.MeliFlex]: 'Mercado Libre',
  [Platform.TikTok]: 'TikTok',
};

export function getPlatformInfo(
  platform?: Platform | string,
): { platform: string; logo: string } | null {
  if (!platform || platform === Platform.Unknown) {
    return null;
  }

  return {
    platform: platformNames[platform] || platform,
    logo: platformLogos[platform] || '',
  };
}

export function getRandomImage(): string {
  const images = [mercadoEnvios, jumpseller, shopify, tiendaNube, woocommerce];
  const randomIndex = Math.floor(Math.random() * images.length);
  return images[randomIndex];
}

export function getRandomPlatform(): string {
  const platforms = ['API V3', 'Self Service', 'Carga Masiva'];
  const randomIndex = Math.floor(Math.random() * platforms.length);
  return platforms[randomIndex];
}
